
import { Component, Vue } from 'vue-property-decorator';

import AppHeader from '@/shared/components/AppHeader.vue';
import LeftMenu from '@/shared/components/LeftMenu.vue';
import Breadcrumb from '@/shared/components/Breadcrumb.vue';

import authService from '@/services/auth-services';
import { APP_CONFIG } from '@/config/app-config';
import commonService from '@/services/common-services';
import AppEvents from '@/event.js';
import { eventBus } from '@/main';

@Component({
  components: {
    AppHeader,
    LeftMenu,
    'bread-crumb': Breadcrumb
  },
})
export default class App extends Vue {
  disableMenuLeft = true;
  disableHeader = true;
  private noteForCustomer = null;
  private isConfirm = false;
  get showMenu() {
    return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
  }
  get hideCustomerMessage() {
    return this.$cookies.get('hideCustomerMessage');
  }
  private async getConfiguration() {
    if(!this.hideCustomerMessage) {
      const result = await commonService.configuration();
      if (result && result.status === 200) {
        this.noteForCustomer = result.data.data.NoteForCustomer;
        this.isConfirm = this.noteForCustomer !== null && this.noteForCustomer !== '' && result.data.data.ShowNoteForCustomer;
        if(this.isConfirm) {
          const name = 'notify-modal';
          const content = this.noteForCustomer;
          this.$modal.show(
            {
              template: `
                <div class="ql-editor customer-modal-content">
                  <div>
                    <span v-html="content"/>
                    <span style="float: right;">
                      <button class="btn" @click="closeForever">Đóng và không hiển thị lại</button>
                      <button class="btn" @click="closeByEvent">Đóng</button>
                    </span>
                  </div>
                </div>
              `,
              props: ['name', 'content'],
              methods: {
                closeForever() {
                  this.$modal.hide(name);
                  this.$cookies.set('hideCustomerMessage', true, 60 * 60 * 24);
                },
                closeByEvent() {
                  this.$modal.hide(name);
                }
              }
            },
            { name, content },
            { name, height: 'auto' }
          )
        }
      }
    }
  }
  private beforeCreate() {
    AppEvents.forEach((item) => {
        this.$on(item.name, item.callback);
      });
    window['getApp'] = this;
  }

  private async created() {
    eventBus.$on(APP_CONFIG.eventBusAction.disableMenuLeft, (data) => {
      this.disableMenuLeft = data;
    });

    eventBus.$on(APP_CONFIG.eventBusAction.disableHeader, (data) => {
      this.disableHeader = data;
    });

    await this.getConfiguration();
  }

  private onCloseModal(eventData: any) {
    this.isConfirm = !eventData.close || false;
    this.$modal.hide('notify-modal');
  }

  private onClickMask() {
    (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', false);
  }
}
